import React, {Component} from 'react';
import {Toolbar, ToolbarGroup, ToolbarSeparator} from 'material-ui/Toolbar';
import DocSearch from './DocSearch';
import UserPanel from './UserPanel';
import LocaleSwitcher from './LocaleSwitcher';

export default class RightTopMenu extends Component {
   render() {
      const toolbarStyle = {
         backgroundColor: 'rgba(0, 0, 0, 0)',
         padding: 0
      };
      return (
         <div style={{marginTop: -4}}>
            <Toolbar style={toolbarStyle}>
               <ToolbarGroup>
                  <DocSearch/>
                  <UserPanel/>
               </ToolbarGroup>
               <ToolbarSeparator style={{marginLeft:0, marginTop: 12}}/>
               <ToolbarGroup>
                  <LocaleSwitcher/>
               </ToolbarGroup>
            </Toolbar>
         </div>
      );
   }
}



// WEBPACK FOOTER //
// ./src/components/RightTopMenu.js